// extracted by mini-css-extract-plugin
export default {"container":"DeleteModal_container__UIHPS","ctn":"DeleteModal_ctn__GMKhB","buttons":"DeleteModal_buttons__vgY9N"};